import { useEffect, useState } from 'react';
import { pingHealth } from '../api/chatClient';

type Status = 'connecting' | 'connected' | 'error';

const POLL_MS = 15_000;

export function useChatStatus() {
  const [status, setStatus] = useState<Status>('connecting');

  useEffect(() => {
    let cancelled = false;
    async function check() {
      const ok = await pingHealth();
      if (!cancelled) setStatus(ok ? 'connected' : 'error');
    }
    void check();
    const id = setInterval(check, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return status;
}

export function StatusDot({ status }: { status: Status }) {
  const color = status === 'connected' ? '#10b981' : status === 'connecting' ? '#f59e0b' : '#ef4444';
  return (
    <span
      title={status}
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        background: color,
        boxShadow: `0 0 0 2px white, 0 0 0 3px ${color}33`,
      }}
    />
  );
}
